import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { structuredTextType } from '../propTypes';
import theme from '../styles/theme';

const Seo = ({ classes, className, content }) => (
  <div className={cn(className, classes.seo)}>
    {/* eslint-disable-next-line react/no-danger */}
    <div dangerouslySetInnerHTML={{ __html: content.seo_content.html }} />
  </div>
);

Seo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  content: PropTypes.shape({
    seo_content: structuredTextType.isRequired,
  }).isRequired,
};

Seo.defaultProps = {
  className: undefined,
};

export default injectSheet({
  seo: {
    color: theme.colors.brandBlack,
    '& h1, h2': {
      fontFamily: theme.fonts.bold,
      fontSize: 20,
      letterSpacing: 1.12,
      lineHeight: 1.5,
      margin: [0, 0, 12],
    },
    '& h2': {
      fontSize: 16,
    },
    '& div > p': {
      fontFamily: `${theme.fonts.body}`,
    },
    '& a, p a:not(.button)[href]': {
      color: theme.colors.link,
      textDecoration: 'underline',
    },
    '& a:hover, a:focus, p a:not(.button)[href]:hover, p a:not(.button)[href]:focus': {
      color: theme.colors.linkHover,
      textUnderlinePosition: 'initial',
    },
  },
})(Seo);
